import React, { useEffect, useState } from 'react';

const WhatsAppButton = () => {
  const [telefono, setTelefono] = useState(null);
  const isMobile = window.innerWidth <= 860;

  useEffect(() => {
    const fetchTelefono = async () => {
      try {
       const response = await fetch('/api/whatsapp');
       
        const data = await response.json();
        if (data?.telefono) {
          setTelefono(data.telefono);
        }
      } catch (error) {
        console.error("Error al obtener el número de WhatsApp:", error);
      }
    };

    fetchTelefono();
  }, []);

  if (!telefono) return null;

  const message = "Hola, quiero más información sobre los cursos.";
  const url = `https://wa.me/${telefono}?text=${encodeURIComponent(message)}`;

  const styles = {
    position: 'fixed',
    bottom: '20px',
    right: '20px',
    zIndex: 1000,
    width: isMobile ? '3rem' : '4rem',
    height: isMobile ? '3rem' : '4rem',
    borderRadius: '50%',
    overflow: 'hidden',
    background: '#25D366', // color WhatsApp
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '0 2px 8px rgba(0,0,0,0.2)'
  };

  return (
    <a href={url} target="_blank" rel="noopener noreferrer" style={styles}>
      <img
        src="https://cdn-icons-png.flaticon.com/512/733/733585.png"
        alt="WhatsApp"
        style={{
          width: '70%', // para que el icono no quede pegado al borde
          height: '70%',
          objectFit: 'contain'
        }}
      />
    </a>
  );
};

export default WhatsAppButton;
